<template>
  <AffiliateInfoPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import AffiliateInfoPage from '@/components/AffiliateInfo.vue'

export default {
  name: 'AffiliateInfo',
  components: {
    // HelloWorld
    AffiliateInfoPage
  }
}
</script>
